// 记录司机信息
// 
const axios = require("axios");
var tmpHost = location.hostname;
var url = 'https://lalaapi.huolala.cn/api/sale/scExInter/bDriverInfo/insertBDriverInfo.do';
if (/-dev|localhost|^192|^172/.test(tmpHost)) {
  url = 'https://oms-dev.huolala.cn/api/sale/scExInter/bDriverInfo/insertBDriverInfo.do';
} else if (/-stg/.test(tmpHost)) {
  url = 'https://oms-stg.huolala.cn/api/sale/scExInter/bDriverInfo/insertBDriverInfo.do'
}

const recordDriver = (options) => {
  return new Promise((resolve, reject) => {
    axios.get(url, {
        params: options
    })
      .then(function (response) {
        console.log('recordDriverrecordDriver', response)
        if (response.data.code === '0') {
          resolve(response.data)
        } else {
          reject(response.data)
        }
      })
      .catch(function (error) {
        reject(error)
      })
  })
}
export default recordDriver